<template>
  <div class="documentos">
    <DocumentosTable :params="params" :fieldsI.sync="fields" />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { ICliente, IConfColumnaPais, IField } from "@/entities";
import { Action, Getter } from "vuex-class";
import { EDirection, IColumnaResponse, IDocumentacionParams } from "@/services";
import DocumentosTable from "@/components/documentacion/DocumentosTable.vue";
import VueFilters from "@/vue-filters";
import { Dictionary } from "vue-router/types/router";

@Component({
  components: {
    DocumentosTable,
  },
  mixins: [VueFilters],
})
export class ByDocumentsComponent extends Vue {
  @Prop({ required: true }) columnsConfig!: IColumnaResponse;
  @Prop({ required: true }) params!: IDocumentacionParams;
  @Getter("getClienteSelected") clienteSelected: ICliente | undefined;

  @Action("fetchColumna") fetchColumna!: (
    codTabla: string
  ) => Promise<IColumnaResponse | undefined>;

  created(): void {
    this.params.size = 10;
    this.params.orderBy = this.columnsConfig.codOrden || "id";
    this.params.direction =
      this.columnsConfig.codTipoOrden === EDirection.ASC ? EDirection.ASC : EDirection.DESC;
    this.$router
      .replace({ path: this.$route.path, query: { ...this.params } as Dictionary<any> })
      .catch(() => {
        // Do nothing
      });
  }

  get fields(): IField[] {
    const visibleKeys = this.columnsConfig?.codColumna?.split(",").filter((s) => s !== "") || [];
    const columnas: IField[] = [
      {
        key: "actions-left",
        label: this.$t("label.acciones"),
        sortable: false,
        thClass: "table-header table-header-active ",
        tdClass: "table-cell-first",
        visible: true,
        class: "table-cell",
        aux: true,
      },
    ];

    this.columnsConfig?.columnas?.forEach((column: IConfColumnaPais) => {
      columnas.push({
        key: column.keyFront,
        label: this.$t("label." + column.codColumna),
        sortable: true,
        thClass: "table-header",
        tdClass: "table-cell-middle",
        thStyle: column.widthFront ? { width: column.widthFront } : {},
        visible: this.isVisible(visibleKeys, column.codColumna),
        class: "table-cell",
        aux: false,
        code: column.codColumna,
        formatter: (value: any): string => {
          if (column.formatType == "Date") {
            return this.filterDate(value);
          } else if (column.formatType == "Number") {
            return this.filterNumber(value, 2);
          }
          return value;
        },
      });
    });

    columnas.push({
      key: "add-columns",
      label: "",
      sortable: false,
      thClass: "table-header table-header-add-columnas",
      tdClass: "table-cell table-add-columns",
      visible: true,
      aux: true,
    });

    return columnas;
  }

  set fields(fields: IField[]) {
    this.columnsConfig.codColumna =
      fields
        .filter((item) => item.visible && !item.aux)
        .map((item) => item.code)
        .join(",") || "";
  }

  isVisible(visibleKeys: string[], column: string): boolean {
    return !visibleKeys.length || !!visibleKeys.find((key) => key === column);
  }

  action(action: { action: string; data?: any }): void {
    if (action.action === "print") {
      alert("print");
    } else if (action.action === "download") {
      alert("download");
    }
  }
}
export default ByDocumentsComponent;
</script>
